import { createSelector } from '@reduxjs/toolkit'

import { apiSlice } from '../hooks/api-slice'
import { sortAuto } from '../hooks/sort-functions'

const createSortedSelector = ({ endpoint, sliceName }) => {
  const sEndpoint = apiSlice.endpoints[endpoint]
  const data = (state, args) => sEndpoint.select(args)(state)?.data
  const column = state => state.sorting[sliceName]?.column
  const ascending = state => state.sorting[sliceName]?.ascending

  return createSelector([data, column, ascending], (data, column, ascending) =>
    sortAuto(data, column, ascending),
  )
}

const mapRendicontiSocieta = (rendiconti, affiliazioniLight, admin) =>
  rendiconti?.map(r => {
    r = {
      ...r,
      balance: r.totalePagato - r.totaleDovuto,
      codiceSocieta: Number(r?.codiceSocieta) || '',
    }

    if (!admin) return r

    const rSoc = affiliazioniLight?.find(
      a => a.codiceSocieta === r?.codiceSocieta,
    )
    return {
      ...r,
      nomeSocieta: rSoc?.nomeSocieta || <i>Società non trovata</i>,
    }
  })

const mapRimborsiArbitri = (rimborsi, arbitri, admin) =>
  rimborsi?.map(r => {
    r = { ...r, isPaid: !!r.datePaid }

    if (!admin) return r

    const rArb = arbitri?.find(a => a.id === r?.idArbitro)
    const nArb = (rArb && `${rArb.cognome} ${rArb.nome}`) || (
      <i>Arbitro non trovato</i>
    )
    return { ...r, cognomenome: nArb }
  })

const createSortedSelectorMapped = ({ endpoint1, endpoint2, sliceName }) => {
  const sEndpoint1 = apiSlice.endpoints[endpoint1]
  const sEndpoint2 = apiSlice.endpoints[endpoint2]
  const data1 = (state, args) => sEndpoint1.select(args)(state)?.data
  const data2 = state => sEndpoint2.select()(state)?.data
  const column = state => state.sorting[sliceName]?.column
  const ascending = state => state.sorting[sliceName]?.ascending
  const admin = state => state.home.infoUtente.admin

  const fMap =
    (sliceName === 'rendiconti' && mapRendicontiSocieta) ||
    (sliceName === 'rimborsi' && mapRimborsiArbitri) ||
    (x => x)

  return createSelector(
    [data1, data2, column, ascending, admin],
    (data1, data2, column, ascending, admin) => {
      const data = fMap(data1, data2, admin)
      return sortAuto(data, column, ascending)
    },
  )
}

export const selectAffiliazioniSorted = createSortedSelector({
  endpoint: 'getAffiliazioni',
  sliceName: 'affiliazioni',
})

export const selectArbitraggiSorted = createSortedSelector({
  endpoint: 'getArbitraggi',
  sliceName: 'arbitraggi',
})

export const selectArbitriSorted = createSortedSelector({
  endpoint: 'getArbitri',
  sliceName: 'arbitri',
})

export const selectCalendariProvvedimentiSorted = createSortedSelector({
  endpoint: 'getCalendariProvvedimenti',
  sliceName: 'provvedimenti',
})

export const selectIscrizioniSorted = createSortedSelector({
  endpoint: 'getIscrizioni',
  sliceName: 'iscrizioni',
})

export const selectRendicontiSorted = createSortedSelectorMapped({
  endpoint1: 'getRendiconti',
  endpoint2: 'getAffiliazioniLight',
  sliceName: 'rendiconti',
})

export const selectRimborsiSorted = createSortedSelectorMapped({
  endpoint1: 'getRimborsi',
  endpoint2: 'getArbitri',
  sliceName: 'rimborsi',
})

export const selectSpostamentiSorted = createSortedSelector({
  endpoint: 'getSpostamenti',
  sliceName: 'spostamenti',
})

export const selectTesseratiSorted = createSortedSelector({
  endpoint: 'getTesserati',
  sliceName: 'tesserati',
})

export const selectDistinteSorted = createSortedSelector({
  endpoint: 'getDistinte',
  sliceName: 'distinte',
})

export const selectTesseratiPlayersSorted = createSortedSelector({
  endpoint: 'getTesseratiPlayersByGaraSquadra',
  sliceName: 'tesseratiPlayers',
})
